import { m } from '@hub/messages';
import { definePageRoute } from '@hub/router/definePageRoute';
import { type DomainParents, defineDomainRoutes } from '@hub/router/domain-routes';
import { getDevicesOptions } from '@platform/api';
import { DevicePaths } from './route.paths';

export default function createDevicesRoutes(parents: DomainParents) {
  const deviceOverviewRoute = definePageRoute(parents, {
    path: DevicePaths.overview,
    title: m.device_general_headline,
    description: m.device_general_description,
    backBehavior: 'legacy',
    page: () => import('./DeviceOverview.page'),
    pendingComponent: () => import('./components/DeviceOverviewSkeleton'),
    query: getDevicesOptions,
    quickAction: {
      to: DevicePaths.overview.path,
      icon: 'devices',
      title: m.device_quick_action_title,
      subline: m.device_quick_action_subline,
      surfaces: ['home-privacy', 'notifications-actions', 'home-network-actions'],
      order: 20,
    },
    flag: 'page-device-overview',
  });

  return defineDomainRoutes({
    authenticated: [deviceOverviewRoute] as const,
    public: [] as const,
  });
}
